export const calculatePPFMaturity = (P, i, n) => {
  i = i / 100;
  return Number(P) * ((Math.pow(1 + i, n) - 1) / i);
};
